import ConfirmPopover from '@/components/common/ConfirmPopover';
import IconButton from '@/components/common/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import { Box, ListItem, ListItemText } from '@mui/material';
import { FC, useState } from 'react';
import UserEventListItemEdit from './UserEventListItemEdit';
import { UserEventItem } from './UserEventsManager';

type UserEventListItemProps = {
  userEvent: UserEventItem;
  onSave?: (newUserEvent: UserEventItem) => void;
  onDelete?: () => void;
};

const UserEventListItem: FC<UserEventListItemProps> = (props) => {
  const [openEdit, setOpenEdit] = useState(props.userEvent && !props.userEvent.event);
  return (
    <ListItem sx={{ gap: 1, pt: 0, pb: 0 }}>
      {openEdit ? (
        <UserEventListItemEdit
          userEvent={props.userEvent}
          onClose={(isEmpty) => {
            setOpenEdit(false);
            if (isEmpty) {
              props.onDelete && props.onDelete();
            }
          }}
          onSave={(newUserEvent) => {
            props.onSave && props.onSave(newUserEvent);
          }}
        />
      ) : (
        <>
          <ListItemText primary={props.userEvent.event} />
          <code>{props.userEvent.label}</code>
          <Box>
            <IconButton
              tooltip='Edit'
              onClick={() => {
                setOpenEdit(true);
              }}
            >
              <EditIcon />
            </IconButton>
            <ConfirmPopover
              text={
                <>
                  Delete <code>{props.userEvent.event}</code>?
                </>
              }
              onConfirm={() => props.onDelete && props.onDelete()}
              skipConfirm={!props.userEvent.event}
              icon={<ClearIcon />}
            />
          </Box>
        </>
      )}
    </ListItem>
  );
};

export default UserEventListItem;
